import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77802330"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-col-centered input-container"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "flex-row-centered" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]

import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
// Components
import BaseContractPage from './BaseContractPage.vue';
import ValidationDataPopup from '@/components/Contracts/ValidationDataPopup.vue';
import ContractValidationOverridePopup from '@/components/Contracts/ContractValidationOverridePopup.vue';
import OverallValidationBooleanDisplay from '@/components/Contracts/OverallValidationBooleanDisplay.vue';
import TickCrossBooleanDisplay from '@/components/TickCrossBooleanDisplay.vue';
import ExpandableText from '@/components/ExpandableText.vue';
import GroupedInputButton from '@/components/GroupedInputButton.vue';
import useSpinnerPopup from '@/services/composables/SpinnerPopup';
// Misc
import IContractPageExpose  from '@/Interfaces/components/IContractPageExpose';
import {ContractValidationType,ContractValidationTypeKeys} from '@/models/enums/ContractValidationType';
import ContractWithValidations from '@/models/ContractWithValidations';
import { contractApprovalValidate } from '@/services/network';
import { contractValidations } from '@/services/network';
import { authService } from '@/auth/authSingleton';
import DateTimeFileName from '@/types/DateTimeFileName';
import DbTableCsvHelper from '@/services/helpers/DbTableCsvHelper';
import useContractValidation from '@/services/composables/ContractValidation';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';
import { DenyFunctionLevelAccess, AuthorisationLevel } from '@/config/AuthConfig';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractValidation',
  setup(__props) {

const route = useRoute();

const $root = ref<IContractPageExpose<ContractWithValidations>>();
const {
    getFlattened,
    getColKeys,
    getBoolKeys
} = useContractValidation();
const validateAccess = computed(()=>!DenyFunctionLevelAccess(AuthorisationLevel.Operator));
const bulkOverrideAccess = computed(()=>!DenyFunctionLevelAccess(AuthorisationLevel.Admin));
const singlularOverrideAccess = computed(()=>!DenyFunctionLevelAccess(AuthorisationLevel.Analyst));

// TABLE
const working = ref(false);
const validationTypeVar = computed(()=>
    route.params.type ?
        (route.params.type as string)?.toUpperCase() as (keyof typeof ContractValidationType) :
        ContractValidationTypeKeys[0]
);
// POPUP
const detailPopupContractID = ref<string>();
const overrideContractIDs = ref<string[]>();
const setToValid = ref(false);

const cols = computed(()=>['contractID', 'ownerID', ...getColKeys($root.value?.downloadedContracts)]);
const boolCols = computed(()=>getBoolKeys($root.value?.downloadedContracts));

async function contractGetAPI(req): Promise<(ContractWithValidations & Record<string, string | number | boolean | undefined>)[]> {
    req.validationType = validationTypeVar.value;
    const res = await contractValidations.post(req);
    const contracts = res.data.contracts.map(x=>new ContractWithValidations(x));
    const flattened = contracts.map(getFlattened);
    return flattened; 
}
async function onValidateClick() {
    if (working.value) return;
    working.value = true;
    const hideSpinner = useSpinnerPopup().show();
    try {
        if (!$root.value) throw new ReferenceError('$root not mounted.');
        const contractIDs = $root.value.getSelected();
        if (contractIDs.length<=0) return;
        const username = authService.getEmailAddress();
        const validationType = validationTypeVar.value;
        const res = await contractApprovalValidate.post({validationType}, {
            username,
            contractIDs,
        });
        useNotifierWithErrFormatter().success({
            msg: 'Successfully validated selected contracts',
        });
        $root.value.searchContracts();
    } catch(error) {
        await useNotifierWithErrFormatter().error({
            errorType: 'Validating Contracts',
            error
        });
    } finally {
        hideSpinner();
        working.value = false;
    }
}
function onRowClicked(contract: ContractWithValidations) {
    detailPopupContractID.value = contract.contractID;
}
function onForceValidClick() {
    onOverrideRequest($root.value?.getSelected(), true);
}
function onForceInvalidClick() {
    onOverrideRequest($root.value?.getSelected());
}
function onOverrideRequest(contractIDs?: string[], _setToValid?: boolean) {
    if (!contractIDs?.length) return;
    setToValid.value = _setToValid ?? false;
    overrideContractIDs.value = contractIDs;
}
function onOverride() {
    detailPopupContractID.value = undefined;
    $root.value?.searchContracts();
}
function exportCSV() {
    try {
        if (!$root.value) throw new ReferenceError('$root not mounted.');
        const contractIDs = $root.value.getSelected();
        if (contractIDs.length<=0) return;
        const selected = new Set(contractIDs);
        const data = $root.value?.downloadedContracts?.filter(x=>selected.has(x.contractID)) ?? [];
        const duplicate = data.map(x=>{
            const tmp = Object.assign({},x);
            tmp.validations = undefined;
            tmp.parsedTestData = undefined;
            tmp.testData = undefined as unknown as string;
            return tmp;
        });
        const dlTime = new DateTimeFileName();
        DbTableCsvHelper.generateCsvDownload(duplicate, `ContractValidations${dlTime}.csv`);
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: 'Exporting csv',
            error
        });
    }
}

watch(validationTypeVar, ()=> {
    if (!!$root.value) {
        $root.value.downloadedContracts = []
    }
} )



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseContractPage, {
    ref_key: "$root",
    ref: $root,
    contractGetAPI: contractGetAPI,
    cols: cols.value,
    contractName: "",
    hasCheckbox: "",
    noSingleDownload: validationTypeVar.value !== 'HIRE_AGREEMENT',
    rowCheckableFilter: ()=>true,
    rowClickedCallback: onRowClicked,
    showTableCount: true
  }, _createSlots({
    validation: _withCtx(({value}) => [
      _createVNode(OverallValidationBooleanDisplay, {
        value: value.validation
      }, null, 8, ["value"])
    ]),
    manualOverride: _withCtx(({value}) => [
      _createVNode(TickCrossBooleanDisplay, {
        value: value.manualOverride
      }, {
        true: _withCtx(() => [
          _createTextVNode("Y")
        ]),
        false: _withCtx(() => [
          _createTextVNode("N")
        ]),
        _: 2
      }, 1032, ["value"])
    ]),
    ValidationMessage: _withCtx(({value}) => [
      _createVNode(ExpandableText, { maxLines: 3 }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(value.ValidationMessage), 1)
        ]),
        _: 2
      }, 1024)
    ]),
    "search-group-extra": _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "default-btn",
          title: `${$root.value?.anyChecked?'':'(Selected contracts with checkboxes first) '}Export data to a csv file.`,
          onClick: exportCSV,
          type: "button"
        }, " Export csv ", 8, _hoisted_6),
        (!bulkOverrideAccess.value && validateAccess.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "default-btn",
              type: "button",
              onClick: onValidateClick,
              title: `${$root.value?.anyChecked?'':'(Selected contracts with checkboxes first) '}Request the server to run checks on the selected contracts, even if they have been validated before.`
            }, " Validate Selected ", 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ValidationDataPopup, {
        modelValue: detailPopupContractID.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detailPopupContractID).value = $event)),
        hasOverride: singlularOverrideAccess.value,
        validationType: validationTypeVar.value,
        onOverride: onOverrideRequest,
        onRequestUpdate: _cache[1] || (_cache[1] = id=>$root.value?.updateContracts(id))
      }, null, 8, ["modelValue", "hasOverride", "validationType"]),
      _createVNode(ContractValidationOverridePopup, {
        modelValue: overrideContractIDs.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((overrideContractIDs).value = $event)),
        validationType: validationTypeVar.value,
        setToValid: setToValid.value,
        onOverride: onOverride
      }, null, 8, ["modelValue", "validationType", "setToValid"])
    ]),
    _: 2
  }, [
    (validateAccess.value)
      ? {
          name: "header-extra",
          fn: _withCtx(() => [
            (bulkOverrideAccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("button", {
                    class: "default-btn",
                    type: "button",
                    onClick: onValidateClick,
                    title: `${$root.value?.anyChecked?'':'(Selected contracts with checkboxes first) '}Request the server to run checks on the selected contracts, even if they have been validated before.`
                  }, " Validate Selected ", 8, _hoisted_2),
                  _createVNode(GroupedInputButton, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "default-btn left-btn",
                        title: "Override the validation results of selected to be valid",
                        onClick: onForceValidClick,
                        type: "button",
                        disabled: working.value
                      }, " Force Valid ", 8, _hoisted_3),
                      _createElementVNode("button", {
                        title: "Override the validation results of selected to be invalid",
                        class: "default-btn",
                        onClick: onForceInvalidClick,
                        type: "button",
                        disabled: working.value
                      }, " Force Invalid ", 8, _hoisted_4)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined,
    _renderList(boolCols.value, (k) => {
      return {
        name: `${k}`,
        fn: _withCtx(({value}) => [
          _createVNode(TickCrossBooleanDisplay, {
            value: (value[k] as boolean | undefined)
          }, null, 8, ["value"])
        ])
      }
    })
  ]), 1032, ["cols", "noSingleDownload"]))
}
}

})